<template>
  <!-- 检索 -->
  <div class="retrieval">
    <!-- <div class="retrieval-colse" @click="berforClose"><i class="el-icon-close"></i> </div> -->
    <div class="retrieval-header-box">
      <div class="header-box-title">全文检索</div>
      <div class="header-box-seach">
        <el-input placeholder="请输入关键词" v-model="searchValue"></el-input>
        <el-button @click="getData" class="seach" type="primary">检索</el-button>
      </div>
    </div>
    <div class="retrieva-main">
      <div class="retrieva-interval">
        全文检索结果 {{ searchNumber }} 条
      </div>
      <div :key="index" class="retrieca-jange" v-for="(item, index) in searchData">
        <div v-html="item.highlight" v-show="item.highlight.length!=0"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getPageContent, pageSearch} from '../../api/exhibition'
  import {mainSearch} from '../../api/resource'

  export default {
    name: 'PortalRetrieval',
    props: {
      bookId: {
        type: String,
      }
    },
    data() {
      return {
        searchValue: '',
        searchNumber: 0,
        searchData: []
      };
    },

    mounted() {
      // this.getPageSeach()
      this.getData()
    },

    methods: {
      berforClose() {
        this.$parent.handClose()
      },
      getData() {
        let params = {
          typeId: this.$store.state.typeId,
          index1: 'ancientbook',
          esParams: [],
          limit: 20,
        }
        const ids = this.$store.state.categoryData.find(e => e.name == '古籍底本')
        const ids2 = this.$store.state.categoryData.find(e => e.name == '精品图书')
        //默认审核和主书检索
        params.esParams.push(
          {
            searchName: "examineState",
            searchRelation: 1,
            searchType: 1,
            searchValue: "1",
          },
          {
            searchName: "ocrFile",
            searchRelation: 1,
            searchType: 1,
            searchValue: this.searchValue,
          },
          {
            searchName: "category",
            searchRelation: 0,
            searchType: 1,
            searchValue: ids.id,
          },
          {
            searchName: "category",
            searchRelation: 0,
            searchType: 1,
            searchValue: ids2.id,
          },
          {
            searchName: "id",
            searchRelation: 1,
            searchType: 1,
            searchValue: this.bookId,
          }
        )
        mainSearch(params).then(res => {
          if (res.data.code == 200) {
            this.searchNumber = res.data.data.count
            this.searchData = res.data.data.list
          }
        })
      },
      // 全文检索词定位
      getPageSeach() {
        pageSearch({
          searchValue: '创世经',
          bookId: this.$route.query.bookId
        }).then(res => {
          // console.log(res);
        })
      },
      // 获取单页识别结果
      getPageContentFun() {
        getPageContent({
          bookId: '',
          page: ''
        }).then(res => {

        })
      }

    },
  };
</script>

<style lang="less" scoped>
  .exhibition-left {
    &.close {
      .retrieval {
        display: none;
      }
    }

    &.open {
      .retrieval {
        display: block;
      }
    }
  }

  .retrieval {
    width: 16.667rem;
    height: 100%;
    position: relative;
    margin: 0;

    .retrieval-colse {
      position: absolute;
      top: 0.885rem;
      right: 1.042rem;
      width: 1rem;
      height: 1rem;
      box-sizing: border-box;
      border: 1px solid #4b2200;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      i {
        font-size: 0.88rem;
        line-height: unset;
      }
    }

    .retrieval-header-box {
      box-sizing: border-box;
      padding: 0.885rem 1.042rem 0.781rem 1.042rem;

      .header-box-seach {
        padding: 0.885rem 1.042rem 0 0;
        display: flex;

        /deep/ .el-input {
          width: 10.625rem;
          height: 2.083rem;
          background-color: #feedc8;
          border-radius: 0.208rem;
          border: solid 0.052rem #dddddd;

          .el-input__inner {
            width: 10.625rem;
            height: 2.083rem;
            background-color: #feedc8;
            border-radius: 0.208rem;
            border: solid 0.052rem #dddddd;
            font-size: 0.833rem;
          }
        }

        .seach {
          width: 3.698rem;
          height: 2.083rem;
          background-color: #feedc8;
          border-radius: 0.208rem;
          border: solid 0.052rem #dddddd;
          color: #333333;
          font-size: 0.833rem;
          margin-left: 0.208rem;
        }
      }
    }

    .retrieva-main {
      .retrieva-interval {
        width: 100%;
        height: 2.083rem;
        background-color: #dddddd;
        border: solid 0.052rem #dddddd;
        line-height: 2.083rem;
        padding-left: 1.042rem;
        font-size: 0.833rem;
        color: #333333;
      }

      .retrieca-jange {
        div {
          margin: .8rem 0;
          padding-left: 1.042rem;
        }
      }
    }
  }
</style>
